import { AnyAction } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';

import { MessageResponse } from '../../../_helpers/iResponse';
import * as Constants from '../constants';
import { IResponseServices } from '../reducers';
import * as Services from '../services';

function* getServices(action: AnyAction) {
  try {
    const payload: IResponseServices = yield call(Services.getServices, action.page, action.filter.trim(), action.statuses);
    yield put({
      type: Constants.GET_SERVICES_SUCCESS,
      payload
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_SERVICES_FAILED, e });
    return action.reject(e);
  }
}
function* cancelService(action: AnyAction) {
  try {
    const response: any = yield call(Services.cancelService, action.id);
    response.data.message ? action.resolve() : action.reject(response.data.message);
  } catch (e) {
    action.reject(e);
  }
}
export const OrderSagas = [
  takeLatest(Constants.CANCEL_SERVICE, cancelService),
  takeLatest(Constants.GET_SERVICES, getServices)
];
